import React, { useState } from "react";
import { 
  Accordion, 
  AccordionContent,
  AccordionTitle,
  Container,
  Grid,
  GridColumn,
  GridRow,
  Icon, 
  Image,
} from "semantic-ui-react";

export default function CommonProjects() {
  const [activeIndex, setActiveIndex] = useState();

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  const accordianTitleStyle = {
    backgroundColor: "#212121",
    padding: "1em 2em 1em 2em",
    borderRadius: "3em",
    margin: "1em 0em 1em 0em",
  }

  const pStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "700",
    color: "#FFFFFF",
		fontSize: "clamp(1.1em, 1vw, 1.2em)",
    lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  }

  const iconStyle = {
    color: "#FFFFFF",
  }

  const GridColumnStyle = {
    padding: "0.5em 0.5em 0.5em 0.5em",
  }

  const GridRowStyle = {
    padding: "0m 0.5em 0em 0.5em",
  }

  return (
    <Accordion fluid>
      <AccordionTitle
        active={activeIndex === 0}
        index={0}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Gates, Fences, Handrails & Balustrades'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 0}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./blackMetalGate.webp" alt="Custom black metal side gate installation" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./brownMetalGate.webp" alt="Large brown metal driveway gate for vehicles" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalGate.webp" alt="Metal car gate on a residential driveway" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./RedMetalBalustrade.webp" alt="Red metal balustrade along a building pathway" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./drivewayBlackMetalGate.webp" alt="Black metal driveway gate on a concrete driveway" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./drivewayMetalGate.webp" alt="Metal car gate for driveway entrance" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./solidBlackMetalGate.webp" alt="Solid black metal driveway gate for security" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>

      <AccordionTitle
        active={activeIndex === 1}
        index={1}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Kitchens & Benches'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 1}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalTimberStorageUnit.webp" alt="Metal and timber storage unit for kitchens" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./basinUnit.webp" alt="Outdoor metal basin unit installation" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>

      <AccordionTitle
        active={activeIndex === 2}
        index={2}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Structural Steelwork, Pipework & Modifications'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 2}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./structuralSteelWork.webp" alt="Structural steel frames at a construction site" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalDrain.webp" alt="Metal drain along a building walkway" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalDrain2.webp" alt="Metal drain installation on a brick wall building" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalPipe.webp" alt="Polished metal Pipe" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./structuralSteelwork2.webp" alt="Structural steelwork and scaffolding on a house" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>

      <AccordionTitle
        active={activeIndex === 3}
        index={3}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Vehicle & Tray Repairs'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 3}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./customMetalUte.webp" alt="White ute with a custom made storage unit on the tray with Custom Metal branding on it" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>

      <AccordionTitle
        active={activeIndex === 4}
        index={4}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Vehicle Accessories & Modifications'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 4}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./carModifications.webp" alt="Car modifiactions installed on the front of a car" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalCarSideStepInstalled.webp" alt="Black metal side step installed on a car" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalCarSideStep.webp" alt="2 Black metal side steps for a car" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalPipes.webp" alt="Metal pipes on a table" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./roofRack.webp" alt="Black metal side roof rack on a ute" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./vehicleRack.webp" alt="Metal vehicle rack on the font of a ute" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>

      <AccordionTitle
        active={activeIndex === 5}
        index={5}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Farm Implements'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 5}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./pushSprayer.webp" alt="Black push sprayer" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./handHeldSprayer.webp" alt="Metal framing for a hand held sprayer" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./handHeldSpayerFrame.webp" alt="Metal frame for a hand held sprayer" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>

      <AccordionTitle
        active={activeIndex === 6}
        index={6}
        onClick={handleClick}
        style={accordianTitleStyle}
      >
        <Grid>
          <GridRow columns={2}>
            <GridColumn width={14}>
              <Container 
                content='Other Projects'
                style={pStyle}
              />
            </GridColumn>
            <GridColumn verticalAlign='middle' textAlign='right' width={2}>
              <Icon name="dropdown" style={iconStyle}/>
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionTitle>
      <AccordionContent active={activeIndex === 6}>
        <Grid columns={3} doubling stackable style={GridRowStyle}>
          <GridRow>
            <GridColumn style={GridColumnStyle}>
              <Image src="./weldMetal.webp" alt="High quality metal weld" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./metalPlatform.webp" alt="Aluminium metal platform with two steps" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./floorPan.webp" alt="Floor pan weld" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./wheelSpats.webp" alt="Black and straight metal wheel spats" fluid />
            </GridColumn>
            <GridColumn style={GridColumnStyle}>
              <Image src="./handrail.webp" alt="Metal handrail on a white building terrace" fluid />
            </GridColumn>
          </GridRow>
        </Grid>
      </AccordionContent>
    </Accordion>
  );
}